/* Кэш ответов GET-ручек: stale-while-revalidate.

   Роутер при переходе между разделами размонтирует экран, поэтому без кэша
   каждый возврат на «Финансы» или «Обзор» начинался с заставки. Здесь ответы
   живут между монтированиями: экран сразу рисуется по сохранённым данным,
   а свежие подтягиваются молча в фоне.

   Записи не удаляем, а помечаем устаревшими: устаревшее показать можно,
   пустой экран — нет. Объём небольшой (десяток ручек), живёт до перезагрузки. */

/** stamp → { data, at, stale } */
const entries = new Map();
/** stamp → Promise: два экрана с одной ручкой делят один запрос */
const inflight = new Map();

/** Ключ записи: путь + нормализованный query */
export const cacheKey = (path, query) => `${path}|${JSON.stringify(query || {})}`;

export const peek = (stamp) => entries.get(stamp) || null;

export function put(stamp, data) {
  entries.set(stamp, { data, at: Date.now(), stale: false });
}

/** Запрос в общий доступ: одновременные вызовы одной ручки не дублируются */
export function shared(stamp, run) {
  const running = inflight.get(stamp);
  if (running) return running;
  // Снимаем только себя: за время запроса под этим ключом мог встать новый
  const p = run().finally(() => {
    if (inflight.get(stamp) === p) inflight.delete(stamp);
  });
  inflight.set(stamp, p);
  return p;
}

/** Помечает запись устаревшей — показываем её, но перечитываем при первом же обращении.
    Запрос «на лету» снимаем с общего доступа: он мог уйти до правки и вернуть старое. */
export function invalidate(stamp) {
  const e = entries.get(stamp);
  if (e) e.stale = true;
  inflight.delete(stamp);
}

/** Любая запись (POST/PATCH/DELETE) могла задеть что угодно — устаревает всё */
export function invalidateAll() {
  for (const e of entries.values()) e.stale = true;
}

/** Смена аккаунта: чужие данные показывать нельзя */
export function clearCache() {
  entries.clear();
  inflight.clear();
}
